import React, { useContext } from 'react';
import TitleBar from '../../comonents/TitleBar';
import BtnShow from '../../comonents/Buttons';
import './index.css'

import { useNavigate } from 'react-router-dom';


// import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie'
import { Context } from '../../context/Context'
// import { EXPRESS_SERVER_URL, COOKIES_EXPIRES_TIME } from "../../config";
// import axios from '../../axios'
import copy from 'copy-to-clipboard';
import Cookies from 'js-cookie'





export default function Game2HashCalculation() {

    const navigate = useNavigate();

    const { userInfo, privateID } = useContext(Context);

    function toMerkleTreePage() {
        navigate('/game2merkletreepage')
    }
    
    return (
        <div>
            <TitleBar backLastPage="" lastPageName="scenario" />
            <div className='text-center'>
                <b> <p className='h3' style={{ color: '#801E9E', paddingTop: '1rem', fontSize: '40px', paddingBottom: '1rem', fontWeight: 'bold' }}>How to Do a Hash Calculation?</p></b>
            </div>

            <div class='RuleForHashGame2_dataBox'>
                <div className='text-center'> <b>The rule of hash calculation:</b></div>
                <p>In the Merkel tree, hash 1 and hash 2 are added to form data 12, and then the hash 12 is obtained using the same method. In the same way, the hash 34 is obtained. The hash 12 and the hash 34 are added together to become data 1234, and the hash 1234 is obtained using the same method, which is the root hash value of block 1.
                </p>

                Each block has six data fields (Data Number, Customer ID, Product ID, Product Quantity, Delivery Date and Product Name).
                A = Value of the Data Number<br />
                B = Value of the Customer ID<br />
                C = Value of the Product ID<br />
                D = Value of the Product quantity<br />
                E =  Value of the Delivery Date<br />
                F =  Value of the Product Name<br />
                <br />
                Data value (for Data 1 to 4): DV(Data) = DV(A + B + C + D + E + F + Previous Merkle Tree Root), where all English letters are converted into numbers through an ASCII table, and then all numbers in the data are added one by one<br /><br />
                Data value (for others): DV(data) = DV(hash + … + hash), where all numbers in the data are added one by one<br /><br />
                Nonce = a value between 1 and 21 (to be adjusted to produce a hash that can be equally divided by 3 AND 7)<br />




            </div>

            <div className="ruleForHashGame2_div_Next">
                <input className="ruleForHashGame2_btn_Next" type="button" value="Next" onClick={e => toMerkleTreePage()} />
            </div>







        </div >
    )
}